import React, { useState, useEffect } from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { IoIosCloseCircleOutline } from 'react-icons/io';

import TabPanel from '../../components/TabPanel';
import Detalhes from './tabs/Detalhes';
import Complementos from './tabs/Complementos';
import Disponibilidade from './tabs/Disponibilidade';

import { CloseButton, DrawerContainer, DrawerTitle } from '../../drawer_styles';
import { AddProductButton } from '../../../styles';

import { useSimpleProduct } from '../../../../../../hooks/newSimpleProduct';
import { useRegisterAdded } from '../../../../../../hooks/registerAdded';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

interface NewProdutoSimplesProps {
  grupo_id: number;
  grupo_descricao: string;
  tipo_produto: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const NewProdutoSimples: React.FC<NewProdutoSimplesProps> = ({
  grupo_id,
  grupo_descricao,
  tipo_produto,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [complementoReleased, setComplementoReleased] = useState(true);
  const [value, setValue] = useState(0);

  const {
    product,
    filledData,
    disponibilidadeReleased,
    disponibilidadeTabClicked,
    handleSetDisponibilidadeTabClicked,
    submit,
    cleanData,
  } = useSimpleProduct();

  const {
    handleSetHasProductUpdated,
    hasProductUpdated,
    drawerWasClosed,
    handleSetDrawerWasClosed,
  } = useRegisterAdded();

  useEffect(() => {
    async function execute(): Promise<void> {
      let btnComplementoClicked = false;
      setComplementoReleased(true);
      setValue(0);

      if (disponibilidadeTabClicked && disponibilidadeReleased) {
        setValue(2);
        setComplementoReleased(false);
        btnComplementoClicked = true;
      }

      if (product.grupo_id && !btnComplementoClicked) {
        setComplementoReleased(false);
        setValue(1);
      }

      if (filledData) {
        setIsOpen(false);
        await submit();
        handleSetHasProductUpdated(true);
      }

      if (hasProductUpdated) setIsOpen(false);

      if (drawerWasClosed) {
        setIsOpen(false);
        handleSetDrawerWasClosed(false);
      }
    }

    execute();
  }, [
    product,
    submit,
    filledData,
    disponibilidadeReleased,
    disponibilidadeTabClicked,
    handleSetHasProductUpdated,
    hasProductUpdated,
    drawerWasClosed,
    handleSetDisponibilidadeTabClicked,
  ]);

  const classes = useStyles();

  const handleChange = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  const toggleDrawer = (open: boolean) => () => {
    setIsOpen(open);
    cleanData();
    handleSetHasProductUpdated(false);
  };

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
    >
      <AddProductButton type="button" onClick={toggleDrawer(true)}>
        + Adicionar Produto
      </AddProductButton>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Novo Produto</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product_tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} style={{ fontSize: '14px' }} />
                    {tipo_produto !== 2 && (
                      <Tab
                        label="Complementos"
                        {...a11yProps(1)}
                        disabled={complementoReleased}
                        style={{ fontSize: '14px' }}
                      />
                    )}
                    {tipo_produto !== 2 && (
                      <Tab
                        label="Disponibilidade"
                        {...a11yProps(2)}
                        disabled={!disponibilidadeReleased}
                        style={{ fontSize: '14px' }}
                      />
                    )}
                  </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                  <Detalhes
                    id_grupo={grupo_id}
                    descricao_grupo={grupo_descricao}
                    tipo_produto={tipo_produto}
                  />
                </TabPanel>

                {tipo_produto !== 2 && (
                  <div>
                    <TabPanel value={value} index={1}>
                      <Complementos />
                    </TabPanel>

                    <TabPanel value={value} index={2}>
                      <Disponibilidade />
                    </TabPanel>
                  </div>
                )}
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </div>
  );
};

export default NewProdutoSimples;
